import React from "react"
export function Holidays(props) {
  return (
    <svg viewBox="0 0 20 20" {...props}>
      <g
        id="prefix__holidays"
        stroke="none"
        strokeWidth={1}
        fill="none"
        fillRule="evenodd"
      >
        <g id="prefix__Group">
          <path
            d="M18.998 16.87v1.065c-.453 0-.71.111-.969.279l-.418.29a2.68 2.68 0 01-1.613.496c-.846 0-1.33-.297-1.71-.563l-.093-.066c-.356-.253-.614-.436-1.197-.436-.454 0-.71.11-.97.279l-.417.29A2.68 2.68 0 019.998 19c-.846 0-1.33-.297-1.71-.563l-.093-.066c-.356-.253-.614-.436-1.197-.436-.453 0-.71.11-.969.279l-.418.29A2.68 2.68 0 013.998 19c-.846 0-1.33-.297-1.71-.563l-.093-.066c-.317-.225-.555-.394-1.014-.429l-.183-.007v-1.064c.847 0 1.33.297 1.71.563l.094.066c.356.253.613.435 1.196.435.519 0 .78-.144 1.081-.353l.116-.082c.395-.28.886-.63 1.803-.63.846 0 1.33.298 1.71.564l.093.066c.357.253.614.435 1.197.435.518 0 .78-.144 1.081-.353l.116-.082c.395-.28.886-.63 1.803-.63.846 0 1.33.298 1.71.564l.093.066c.357.253.614.435 1.197.435.519 0 .78-.144 1.081-.353l.116-.082c.395-.28.886-.63 1.803-.63zM13.701 2.15l.218.054c3.128.83 5.013 3.964 4.297 7.067l-.054.216-5.071-1.346-1.357 5.015a14.514 14.514 0 016.348 2.344c-.342.093-.646.252-.995.486l-.394.272c-.221.142-.389.194-.696.194-.255 0-.414-.036-.588-.13l-.14-.086-.186-.129c-.716-.508-1.212-.72-2.086-.72-.676 0-1.184.154-1.683.452l-.234.15-.388.27c-.22.141-.388.193-.695.193-.334 0-.473-.043-.787-.256l-.342-.238a3.125 3.125 0 00-1.87-.57c-.677 0-1.185.153-1.684.45l-.234.15-.387.27c-.221.142-.389.194-.696.194-.334 0-.473-.043-.787-.256l-.342-.238a3.267 3.267 0 00-.962-.457l.341-.22a14.539 14.539 0 017.75-2.227l.21.003 1.435-5.301L6.57 6.409c.838-3.1 3.999-4.969 7.13-4.259z"
            id="prefix__holidays"
            fill="currentColor"
          />
        </g>
      </g>
    </svg>
  )
}
